import moment from 'moment'
import { OrderTypes } from '@/components/efriends/sortFactory'

export default function initialState() {
  const state = {
    global: {
      tenant: process.env.VUE_APP_TENANT,
      environment: process.env.VUE_APP_ENVIRONMENT,
      appUrl: process.env.VUE_APP_URL,
      appVersion: '2.2.0',
      reemApiVersion: 1,
      backendApiVersion: '2.2',
      cubeApiVersion: 2,
      isLoading: true,
      // Whether or not the app is ready to be used. For this to be true the user
      // must be logged in, must have selected a cube and the initializeApp request
      // must have returned successfully.
      appInitialized: false,
      googleMapsApiKey: false,
      assetsPath: '/img',
      googleMapsStaticApiBaseUrl: false,
      googleMapsJavascriptBaseUrl: false,
      googleMapsJavascriptStatus: false,
      // How long to animate the change between values for meter data.
      wattageTweenDuration: 0.8,
      appUpdateAvailable: false,
      // Used for prices when shown to consumers.
      vatFactor: 1.2,
      serviceWorkerRegistration: false,
      pushSubscription: false,
      mapSideBar: {
        visible: false,
      },
      slideins: {
        menu: {
          visible: false,
        },
        notifications: {
          visible: false,
        },
        friends: {
          visible: false,
        },
      },
      mainRouteNames: ['home', 'history', 'efriends', 'devices'],
      contact: {
        phone: '0043295320102',
        phoneFormatted: '02953/20102',
        email: 'support@efriends.at',
      },
    },
    crm: {
      clientId: process.env.VUE_APP_CLIENT_ID,
      redirectUrl: false,
    },
    urls: {
      backend: process.env.VUE_APP_BACKEND_URL,
      reem: process.env.VUE_APP_REEM_URL,
      authentication: process.env.VUE_APP_AUTH_URL_BASE,
      deviceManager: process.env.VUE_APP_DEVICE_MANAGER_URL,
      deviceControl: false,
      deviceScheduler: false,
      deviceNetworkManager: false,
    },
    authentication: {
      cookieName: 'efToken',
      // 10 years from now.
      cookieLifeTime: 365 * 10,
      userNameCookieName: '__efu',
      userName: false,
      backendAccessToken: false,
      userIsAuthenticated: false,
      errorMessage: null,
    },
    forms: {
      login: {
        state: false,
      },
      // When a logged-in user starts the reset password process to change the password.
      changePassword: {
        state: false,
      },
      // The form where a non-authenticated user inputs an email address to get an
      // email with a link.
      passwordReset: {
        state: false,
        message: false,
      },
      // The form where a new password is set.
      newPassword: {
        state: false,
        message: false,
      },
      defaultSellingPrice: {
        state: false,
      },
      // The consumer component registers itself here so we can keep track.
      consumers: {},
      cubePersonalization: {
        state: false,
      },
    },
    strings: {
      platform: {
        name: 'eFriends Map',
      },
      global: {
        title: process.env.VUE_APP_APP_NAME,
        save: 'Speichern',
        cancel: 'abbrechen',
        updateApp:
          'Eine neue Version dieser App ist verfügbar und wird in wenigen Sekunden geladen.',
        back: 'zurück',
        changePassword: 'Passwort ändern',
        logout: 'Abmelden',
        notifications: 'Push-Benachrichtigungen',
        toggleMenuSlidein: 'Menü ein-/ausblenden',
        toggleFriendsSlidein: 'Liste ein-/ausblenden',
        cubeNotReachableMessage:
          'Wir können deinen Cube im Moment nicht erreichen.<br>Bitte stelle sicher, dass die Internetverbindung funktioniert.',
      },

      authentication: {
        provideUserNameAndPassword:
          'Bitte geben Sie Benutzername und Passwort an.',
        passwordResetMailSent:
          'Wir haben ein E-Mail mit einen Link zum Zurücksetzen des Passworts gesendet. Es kann ein paar Minuten dauern, bis du das E-Mail erhältst.<br>Falls du kein E-Mail erhalten solltest, versuche es bitte erneut.',
      },
      efriends: {
        menuTitle: process.env.VUE_APP_FRIENDS_MENU_TITLE,
        title: process.env.VUE_APP_FRIENDS_TITLE,
        mapTitle: 'Karte',
        mapSubtitle: process.env.VUE_APP_FRIENDS_SUBTITLE,
        listTitle: 'Liste',
        donateesTitle: 'Ich spende an',
        contributorsTitle: 'Ich erhalte Spenden von',
        producersTitle: 'Ich beziehe von (Bruttopreise)',
        consumersTitle: 'Ich liefere an (Nettopreise)',
        doConnectButton: 'Strom beziehen',
        doDonateButton: 'Strom spenden',
        stopDonatingButton: 'Nicht mehr spenden',
        mapsPopup: {
          connectionTextBidirectional: 'Du beziehst von und lieferst an @cube',
          connectionTextProducer: 'Du beziehst von @cube',
          connectionTextConsumer: 'Du lieferst an @cube',

          connectionTextDonate: 'Du spendest an @cube',
          connectionTextDonateAndConsume:
            'Du spendest an und beziehst von @cube',

          connectionTextContributes: '@cube spendet an dich',
          connectionTextContributesAndConsume:
            '@cube spendet an dich und du beziehst',
        },
        currentPrice: 'Preis / kWh',
        nextPriceLabel: 'Neuer Preis',
        showMore: 'Mehr anzeigen',
        hasFreeCapacity: 'Du kannst dich mit @cube verbinden.',
        sort: 'Sortieren',
        sorting: {
          lowestPriceFirst: 'Günstige zuerst',
          highestPriceFirst: 'Teure zuerst',
          shortestDistanceFirst: 'Nahe zuerst',
          longestDistanceFirst: 'Entfernte zuerst',
        },
      },
      history: {
        menuTitle: 'Verlauf',
      },
      availableCubes: {
        title: 'Bitte wählen Sie einen Vertrag aus',
      },
      home: {
        menuTitle: 'Aktuell',
        consumption: 'Mein Verbrauch',
        production: 'Meine Einspeisung',
        communityConsumption: 'Marktplatz Community',
        supplierConsumption: process.env.VUE_APP_SUPPLIER_NAME,
        balance: 'Bilanz',
      },
      login: {
        user: 'Benutzername/E-Mail',
        password: 'Passwort',
        submit: 'Anmelden',
        pass: 'Anmelden',
        resetPassword: 'Zurücksetzen',
      },
      newPassword: {
        submit: 'Passwort ändern',
      },
      settings: {
        menuTitle: 'Einstellungen',
        noInvoices: 'Es sind noch keine Rechnungen vorhanden.',
        noDownloads: 'Es sind keine Downloads vorhanden.',
        uploadImage: 'Bild hochladen',
        publicCubeDescriptionLabel: 'Beschreibung',
      },
      units: {
        watt: 'W',
        kilowatt: 'kW',
        wattPeak: 'Wp',
        kilowattPeak: 'kWp',
        wattHours: 'Wh',
        kilowattHours: 'kWh',
        megawattHours: 'MWh',
        cent: 'Cent',
        centPerKilowatt: 'Cent / kWh',
      },
      productionTypes: {
        pv: 'Photovoltaikanlage',
        wind: 'Kleinwindradanlage',
        water: 'Kleinwasserkraftwerk',
        kleinwindkraft: 'Kleinwindradanlage',
        kleinwasserkraft: 'Kleinwasserkraftwerk',
        biogas: 'Biogasanlage',
        none: 'Bezugskunde',
      },
      energyTypes: {
        pv: 'Photovoltaik',
        wind: 'Windkraft',
        water: 'Wasserkraft',
        biogas: 'Biogas',
        unknown: 'Unbekannt',
        supplier: 'eFriends Energy',
      },
      map: {
        toggleSidebarText: 'Liste',
        xOpenConnections: '@num freie EnergyLines',
      },
      cubeFilter: {
        activeFilters: 'Aktive Filter: ',
        filter: 'Filtern',
        onlyProducers: 'Nur Produzenten',
        onlyProducersWithCapacity: 'Von denen ich beziehen kann',
        energyType: 'Energieerzeugung',
        allEnergyTypes: 'Alle Arten',
        price: 'Preis',
        from: 'Von:',
        to: 'Bis:',
        priceUnit: 'ct/kWh',
        reset: 'Zurücksetzen',
        results: 'Ergebnisse',
      },
      myData: {
        menuTitle: 'Meine Daten',
      },
      downloads: {
        menuTitle: 'Downloads',
      },
      experts: {
        menuTitle: 'Expertenmodus',
      },
      invoices: {
        menuTitle: 'Rechnungen',
      },
      aboutApp: {
        menuTitle: 'Über die App',
      },
      devices: {
        menuTitle: 'Geräte',
        scan: 'Neue Geräte suchen',
        modes: {
          measure: 'Verbrauch messen',
          manual: 'Manuell',
          optimized: 'Zeitschaltuhr',
        },
        name: 'Name',
        description: 'Beschreibung',
        consumption: 'Verbrauch',
        consumptionOnDay: 'Verbrauch am @date',
        consumptionInMonth: 'Verbrauch im @date',
        timer: 'Zeitschaltuhr',
        activateTimer: 'Zeitschaltuhr aktivieren',
        manual: 'Manuell',
        settings: 'Einstellungen',
        applianceType: 'Geräteart',
        isOn: 'ein',
        isOff: 'aus',
        turnOn: 'Gerät einschalten',
        turnOff: 'Gerät ausschalten',
        deleteDevice: 'Dieses Gerät löschen',
        isNotReachable: 'nicht erreichbar',
        deviceIsNotReachable:
          'Wir können <em>@device</em> aktuell nicht erreichen.',
        applianceTypeHelpText:
          'Jede Geräteart wird in der Verbrauchsgrafik zur besseren Übersichtlichkeit in einer eigenen Farbe gezeigt.',
        currentConsumption: 'Aktueller Verbrauch: @value',
        currentTemperature: 'Temperatur: @value',
        noDevicesAdded: 'Du hast noch keine Geräte hinzugefügt.',
        noDeviceData: 'Für diesen Zeitraum sind keine Gerätedaten verfügbar.',
        errorTimeSlotsInvalid:
          'Ungültige Zeitangabe. Die Endzeit muss vor der nächsten Startzeit liegen.',
        timerActiveCantSwitch:
          'Für dieses Gerät ist die Zeitschaltuhr ist aktiv.',
        manualSwitchingWhileTimerActiveMessage:
          'Wenn du die myStrom Steckdose händisch ein- bzw ausschaltest, während die Zeitschaltuhr aktiv ist, wird die Zeitschaltuhr deaktiviert.',
        defaultOnState: 'Einschalten wenn nicht erreichbar',
      },
      notifications: {
        menuTitle: 'Benachrichtigungen',
        title: 'Benachrichtigungen',
        markAsRead: 'Als gelesen markieren',
        markAllAsRead: 'Alle als gelesen markieren',
        showMore: 'mehr',
        toggleUnread: 'Gelesene anzeigen',
        welcomeNotification:
          'Wunderbar, du erhältst ab sofort Benachrichtigungen für deine eFriends App!,',
      },
      basePricePopup: {
        title: 'Verkaufspreis deines Stroms',
        text: 'Du hast noch keinen Verkaufspreis für deinen Strom bestimmt.',
        button: 'Verkaufspreis festlegen',
      },
      days: {
        all: 'Alle Tage',
        monday: 'Montag',
        tuesday: 'Dienstag',
        wednesday: 'Mittwoch',
        thursday: 'Donnerstag',
        friday: 'Freitag',
        saturday: 'Samstag',
        sunday: 'Sonntag',
      },
      timer: {
        addSlot: 'hinzufügen',
        removeSlot: 'entfernen',
      },
    },
    availableCubes: [],
    cube: {
      id: false,
      name: false,
      nickName: false,
      hasProduction: false,
      latitude: false,
      longitude: false,
      // This is called openConnectionsAvailable in the api and represents the
      // number of energy lines this cube can still use for new connections.
      unusedEnergyLines: 0,
      openConnectionsAvailable: 0,
      producers: [],
      consumers: [],
      consumerPricesLoaded: false,
      consumerPrices: {},
      showInverterData: false,
      showNotificationsRequestPopup: false,

      // -1: User actively disabled notifications,
      // 0: Undecided, the user did not take an action yet (default).
      // 1: The user enabled notifications and the backend has the subscription for the current session stored.
      // 2: The user enabled notifications but the backend does not have the subscription for the current session stored.
      webPushValue: 0,
      notificationsValue: 0,

      connectionsReceived: false,
      descriptionText: '',
      images: false,
      imageCroppaQuality: 2,

      planName: false,
      iotDeviceId: false,

      localHostName: false,
      localChartServicePort: false,
      localWebSocketPort: false,
      remoteHostName: false,
      remoteChartServicePort: false,
      remoteWebSocketPort: false,
      remoteWebSocketPath: false,
      connectionPriorities: [
        {
          title: 'Hoch',
          value: 'high',
        },
        {
          title: 'Standard',
          value: 'default',
        },
        {
          title: 'Niedrig',
          value: 'low',
        },
      ],
      notifications: [],
      devices: [],
      devicesLoaded: false,
      showDeleteDevicePopup: false,
      applianceTypes: {
        heater: 'Heizung',
        fridge: 'Kühlschrank',
        boiler: 'Boiler',
        freezer: 'Gefrierschrank/-truhe',
        pump: 'Pumpe',
        light: 'Licht',
        pv: 'PV Panel',
        unknown: 'Anderes Gerät',
      },
      deviceConsumptionTimespans: [
        {
          title: 'Tag',
          value: 'day',
        },
        {
          title: 'Monat',
          value: 'month',
        },
      ],
      newDevices: [],
      supplier: {
        name: false,
        shortName: false,
        logoUrl: false,
      },
    },
    map: {
      center: {
        latitude: null,
        longitude: null,
      },
      defaultZoom: 14,
      // TODO Use these values from getAppConfig request, when they are returned.
      coordinateConstraints: {
        latMin: 46,
        latMax: 50,
        lonMin: 9.5,
        lonMax: 17.5,
      },
      globalCubesList: [],
      globalProducerPrices: {},
      sidebar: {
        numCubesShown: 20,
      },
      styles: [
        {
          elementType: 'geometry',
          stylers: [
            {
              color: '#f5f5f5',
            },
          ],
        },
        {
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#616161',
            },
          ],
        },
        {
          elementType: 'labels.text.stroke',
          stylers: [
            {
              color: '#f5f5f5',
            },
          ],
        },
        {
          featureType: 'administrative',
          elementType: 'geometry',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'administrative.country',
          elementType: 'geometry.stroke',
          stylers: [
            {
              color: '#bbbbbb',
            },
            {
              visibility: 'on',
            },
            {
              weight: 3,
            },
          ],
        },
        {
          featureType: 'administrative.land_parcel',
          elementType: 'labels',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'administrative.land_parcel',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#bdbdbd',
            },
          ],
        },
        {
          featureType: 'administrative.province',
          elementType: 'geometry.stroke',
          stylers: [
            {
              color: '#7f7f7f',
            },
            {
              visibility: 'on',
            },
            {
              weight: 1,
            },
          ],
        },
        {
          featureType: 'landscape.man_made',
          elementType: 'geometry.fill',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'landscape.man_made',
          elementType: 'geometry.stroke',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'poi',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [
            {
              color: '#eeeeee',
            },
          ],
        },
        {
          featureType: 'poi',
          elementType: 'labels.text',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'poi',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#757575',
            },
          ],
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [
            {
              color: '#e5e5e5',
            },
          ],
        },
        {
          featureType: 'poi.park',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e',
            },
          ],
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [
            {
              color: '#ffffff',
            },
          ],
        },
        {
          featureType: 'road',
          elementType: 'geometry.stroke',
          stylers: [
            {
              color: '#e0e0e0',
            },
            {
              visibility: 'on',
            },
          ],
        },
        {
          featureType: 'road',
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'road.arterial',
          stylers: [
            {
              color: '#eeeeee',
            },
          ],
        },
        {
          featureType: 'road.arterial',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#ffffff',
            },
          ],
        },
        {
          featureType: 'road.arterial',
          elementType: 'geometry.stroke',
          stylers: [
            {
              color: '#e0e0e0',
            },
          ],
        },
        {
          featureType: 'road.arterial',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#757575',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry',
          stylers: [
            {
              color: '#dadada',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#fffbdc',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry.stroke',
          stylers: [
            {
              color: '#e9e2c1',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#616161',
            },
          ],
        },
        {
          featureType: 'road.local',
          elementType: 'labels',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'road.local',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e',
            },
          ],
        },
        {
          featureType: 'transit',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [
            {
              color: '#c9c9c9',
            },
          ],
        },
        {
          featureType: 'water',
          elementType: 'geometry.fill',
          stylers: [
            {
              color: '#ccf0ff',
            },
          ],
        },
        {
          featureType: 'water',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#9e9e9e',
            },
          ],
        },
      ],
    },
    currentReads: {
      updateDotsStepDuration: 400,
      wattsPerDot: 500,
      dotIndex: 0,

      balance: 0,
      consumption: 0,
      production: 0,
      fromCommunity: 0,
      fromSupplier: 0,
      communityConsumable: 0,
      communityShareable: 0,

      dotCoordinates: {
        positiveX: 0,
        positiveY: 0,
        negativeX: 0,
        negativeY: 0,
      },
      // Note that we're setting this to true even though we don't know at the
      // beginning. This is only set to false if we know we can't reach the cube
      // and want to show an error regarding this.
      isCubeReachable: true,
      backendMeterDataInterval: false,
      backendMeterDataIntervalDuration: 10000,
    },
    settings: {
      contractData: {
        // Whether or not we got contract data from reem already.
        loaded: false,

        meterPointId: '',
        contractId: '',
        fullName: '',
        nickName: '',
        phone: '',
        email: '',
        cubeAddress: {
          address: '',
          zip: '',
          city: '',
          country: '',
        },
        billingAddress: {
          address: '',
          zip: '',
          city: '',
          country: '',
        },
      },
      selectedInvoiceYear: false,
      invoices: [],
      downloads: [],
      producerSettings: {
        // These settings will be overwritten after the getAppConfigRequest.
        minDefaultSellingPrice: 0.0,
        maxDefaultSellingPrice: 0.1,
        defaultSellingPriceStepSize: 0.001,

        // Note that we show the popup asking a user to set a default selling price
        // only if it's value is false. We do this so we only show if after
        // requesting the prices and know that there's no price set yet.
        // Otherwise the popup would be shown for a moment everytime the app loads.
        defaultSellingPrice: 0,
        nextDefaultSellingPrice: {
          // Note that we don't set the price in order to allow the app to hide
          // the next prices if the requests don't arrive in time.
          // price: 0,
          date: false,
        },
      },
      expertSettings: {},
      cubeOrder: OrderTypes.shortestDistanceFirst,
    },
    historySelectedDate: moment().startOf('day').toDate(),
    historyData: {
      // Whether or not we have received the default history data (today).
      received: false,
      labels: [],
      datasets: {
        fromSupplier: [],
        fromCommunity: [],
        toCommunity: [],
        communityConsumable: [],
        inverterProduction: [],
      },
    },
    tradingStatistics: {
      received: false,
      lastUpdate: false,
      datasets: {
        consumedEnergyTypes: {
          data: [],
          labels: [],
          backgroundColor: [],
          raw: [],
        },
        producers: {
          data: [],
          labels: [],
          backgroundColor: [],
          raw: [],
        },
        consumers: {
          data: [],
          labels: [],
          backgroundColor: [],
          raw: [],
        },
      },
    },
    notificationTypeGroups: {
      community: [
        'price_change',
        'consumer_connected',
        'sharing_request',
        'donation_notification',
        'consumer_disconnected',
        'producer_disconnected',
      ],
      invoice: ['service_new_invoice'],
      'meter-read': ['service_cube_not_reachable'],
      devices: [],
    },
    cubeFilter: {
      numberOfActiveFilters: 0,
      showOnlyProducers: false,
      showOnlyProducersWithCapacity: false,
      energyType: 'all',
      priceMin: 0,
      priceMax: 10,
    },
  }

  return state
}
